import React from "react";
import ReadyMadeFormStatus from "./readyMade/ReadyMadeFormStatus";
import ReadyMadeFormActions from "./readyMade/ReadyMadeFormActions";
import { SHOP_KEY } from "./readyMade/ReadyMadeProductForm.shared";
import ReadyMadeFormContent from "./readyMade/ReadyMadeFormContent";
import useReadyMadeProductForm from "./readyMade/useReadyMadeProductForm";

const ReadyMadeProductForm = ({
  initialData,
  onSubmit,
  loading = false,
  error = "",
  errorMeta = null,
  saveSuccess = false,
  submitLabel = "Save Ready-Made Product",
  shopKey = SHOP_KEY,
  isEditing = false,
}) => {
  const {
    form,
    draftRestored,
    submitError,
    submitDisabled,
    conflictMessage,
    setField,
    setVariantField,
    setImages,
    addVariant,
    removeVariant,
    discardDraft,
    handleSubmit,
  } = useReadyMadeProductForm({
    initialData,
    onSubmit,
    loading,
    error,
    errorMeta,
    saveSuccess,
    shopKey,
  });

  return (
    <form className="admin-product-form" onSubmit={handleSubmit}>
      <ReadyMadeFormStatus
        draftRestored={draftRestored}
        isEditing={isEditing}
        conflictMessage={conflictMessage}
        error={error}
        submitError={submitError}
        submitDisabled={submitDisabled}
        discardDraft={discardDraft}
      />

      <ReadyMadeFormContent
        form={form}
        shopKey={shopKey || SHOP_KEY}
        submitDisabled={submitDisabled}
        setField={setField}
        setVariantField={setVariantField}
        setImages={setImages}
        addVariant={addVariant}
        removeVariant={removeVariant}
      />

      <ReadyMadeFormActions
        loading={loading}
        submitLabel={submitLabel}
        submitDisabled={submitDisabled}
        discardDraft={discardDraft}
      />
    </form>
  );
};

export default ReadyMadeProductForm;
